export const updateBasicDetailsWorkOrder = (type, details) => ({
    type: type,
    //"UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY",
    payload: details,
});
export const mandatoryFieldsBasicDetailsWorkOrder = (type, details) => ({
    type: type,
    //"UPDATE_WORK_ORDER_BASIC_DETAILS_MANDATORY_FIELDS",
    payload: details,
});
export const mandatoryFieldsAssesmentsWorkOrder = (type, details) => ({
    type: "UPDATE_WORK_ORDER_ASSESMENTS_MANDATORY_FIELDS",
    //"UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY",
    payload: details,
});

export const completionInfoMandatoryFields = (type, details) => ({
    type: type,
    //"UPDATE_COMPLETION_INFO_MANDATORY_FIELDS",
    payload: details,
});

export const partReplacementDetails = (type, details) => ({
    type: "PART_REPLACEMENT",
    //"UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY",
    payload: details,
});

export const updatePartReplacementDetails = (type, details) => ({
    type: "UPDATE_PART_REPLACEMENT",
    //"UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY",
    payload: details,
});

export const clearPartRepalacement = (type, details) => ({
    type: type,
    //"CLEAR_PART_REPLACEMENT",
    payload: details,
});

export const costInfoDetails = (type, details) => ({
    type: 'COST_INFO',
    //"UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY",
    payload: details,
});

export const assessmentsDetails = (type, details) => ({
    type: type,
    //"CREATE_ASSESSMENTS",
    payload: details,
});

export const createRepairTracker = (type, details) => ({
    type: type,
    //"CREATE_ASSESMENTS",
    payload: details,
});

export const createAssesments = (type, details) => ({
    type: type,
    //"CREATE_ASSESMENTS",
    payload: details,
});


export const addRepairTrackerDetails = (type, details) => ({
    type: type,
    //"ADD_REPAIR_TRACKER_DETAILS",
    payload: details,
});

export const updateRepairTrackerDetails = (type, details) => ({
    type: type,
    //"UPDATE_REPAIR_TRACKER_DETAILS",
    payload: details,
  });
  

export const deleteRepairTracker = (type, details) => ({
    type: type,
    //"DELETE_REPAIR_TRACKER",
    payload: details,
});

export const clearRepairtracker = (type, details) => ({
    type: type,
    //"CLEAR_REPAIRTRACKER",
    payload: details,
});



export const singlepageRepairtracker = (type, details) => ({
    type: type,
    //"CREATE_REPAIR_TRACKER",
    payload: details,
});

export const saveSignature = (type, details) => ({
    type: type,
    //"CREATE_REPAIR_TRACKER",
    payload: details,
});

export const updateAssessmentsPartsRequired = (type, value) => ({
    type: type,
    payload: value,
});

export const updateAssessmentsPartsInitialState = (type, value) => ({
    type: type,
    payload: value,
});

export const updateOutsourceDetails = (type, value) => ({
    type: type,
    // "SET_VENDORFIELD"
    payload: value,
});

export const updateWorkOrderStatus = (type, value) => ({
    type: type,
    //"STATUS_CHANGES"
    payload: value,
});

export const checkFormSubmittedForWorkOrder = (type, value) => ({
    type: type,
    //"CHECK_FORMSUBMITTED_WORKORDER"
    payload: value,
  });